import { getTimeSheet1, getTimeSheet2, getTimeSheet3 } from "../../../api/users";
import { showToastError } from "../../../services/toast";
import { useProductionStore } from "../../../stores/production";

const SendForTimeSheet = () => {
    const { formData, setProduction2, setIsLoading } = useProductionStore();

    const handleTimeSheetRequest = (getTimeSheetFunction: (idUser: number, date: string) => Promise<any>) => {
        setIsLoading(true);
        getTimeSheetFunction(formData.idUser, formData.date)
            .then((res) => {
                // Trier les données pour mettre "Administratif" en premier, puis les autres par ordre alphabétique
                const sortedTimes = res.data.times.sort((a: any, b: any) => {
                    if (a.client === "Administratif") {
                        return -1;
                    } else if (b.client === "Administratif") {
                        return 1;
                    } else {
                        // Trier les autres par ordre alphabétique
                        return a.client.toString().localeCompare(b.client.toString());
                    }
                });

                // Garder la structure complète de l'objet avec times trié
                const sortedData = {
                    ...res.data,
                    times: sortedTimes
                };

                setProduction2(sortedData);
            })
            .catch(() => {
                showToastError("Une erreur est survenue.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleSend1 = () => handleTimeSheetRequest(getTimeSheet1);
    const handleSend2 = () => handleTimeSheetRequest(getTimeSheet2);
    const handleSend3 = () => handleTimeSheetRequest(getTimeSheet3);

    return (
        <div className='flex justify-start items-center'>
            <button
                className="w-44 bg-linear-to-r   from-blue-600 to-dca-blue opacity-80 text-white p-2 rounded-lg hover:opacity-100 cursor-pointer font-Nunito transition-all duration-300 flex justify-center items-center mr-2"
                onClick={handleSend1}
            >
                Cumul
            </button>
            <button
                className="w-44 bg-linear-to-r   from-blue-600 to-dca-blue opacity-80 text-white p-2 rounded-lg hover:opacity-100 cursor-pointer font-Nunito transition-all duration-300 flex justify-center items-center mr-2"
                onClick={handleSend2}
            >
                Facturable
            </button>
            <button
                className="w-44 bg-linear-to-r   from-blue-600 to-dca-blue opacity-80 text-white p-2 rounded-lg hover:opacity-100 cursor-pointer font-Nunito transition-all duration-300 flex justify-center items-center mr-2"
                onClick={handleSend3}
            >
                Non facturable
            </button>
        </div>
    )
}

export default SendForTimeSheet
